import React from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./Hero.module.sass";
import ScrollButton from "../../../components/ScrollButton";
import Image from "../../../components/Image";

const HeroApprentissage = ({ scrollToRef }) => {
  return (
    <div className={styles.hero}>
      <div className={cn("container", styles.container)}>
        <div className={styles.col}>
          <div className={styles.preview}>
            {/* Main hero image */}
            <div className={styles.heroImage}>
              <img
                src="/images/content/ContractHero.svg"
                alt="Logiciel contrat apprentissage - Génération CERFA automatique Edutio"
                className={styles.contractHero}
              />
            </div>
            
            {/* Animated CERFA background */}
            <div className={styles.cerfaBackground}>
              <img
                src="/images/content/CerfaIllus.png"
                alt="CERFA Document"
                className={styles.cerfaIllus}
              />
            </div>
            
            {/* Avatar in foreground */}
            <div className={styles.avatarForeground}>
              <img
                src="/images/content/AvatarRight.svg"
                alt="User Avatar"
                className={styles.avatarRight}
              />
            </div>
          </div>
        </div>
        <div className={styles.col}>
          <div className={styles.wrap}>
            <div className={cn("stage", styles.stage)}>
              Contrats d'apprentissage CFA
            </div>
            <h1 className={cn("h1", styles.title)}>
              Contrat d'apprentissage : génération CERFA automatique
            </h1>
            <div className={styles.text}>
              Logiciel de gestion des contrats d'apprentissage pour CFA : générez vos CERFA automatiquement, envoyez aux OPCO en 1 clic et suivez vos dossiers en temps réel. +100 CFA en France.
            </div>
            <div className={styles.btns}>
              <Link className={cn("button", styles.button)} to="/contact">
                Essayer gratuitement
              </Link>
              <Link
                className={cn("button-stroke", styles.button)}
                to="/contact"
              >
                Contact
              </Link>
            </div>
            <div className={styles.scrollWrapper}>
              <ScrollButton
                onScroll={() => {
                  if (scrollToRef && scrollToRef.current) {
                    scrollToRef.current.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className={styles.scroll}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroApprentissage;
